import React from 'react'

export default function Materials() {
    return (
        <div style={{ padding: '10px 30px' }}>
            {/* <TabComponent dataTabs={dataTabs} /> */}
        </div>
    )
}
